import React from "react";
import {connect} from "react-redux";
import DeployMarketAppComponent from "./DeployMarketAppComponent";
import {deployApplication, updateDeployMarketAppData} from "./deployMarketApp";
import {LOGIN} from "reducers/authenticationNew";


class DeployMarketAppPage extends React.Component {

  render() {
    return <DeployMarketAppComponent {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.deployMarketApp.loading,
    updating: state.deployMarketApp.updating,

    isAuthenticated: state.authentication.isAuthenticated,
    userId: state.authentication.isAuthenticated ? state.authentication.userId : "",
    username: state.authentication.isAuthenticated ? state.authentication.username : "",
    enterprises: state.userData.enterprises.length > 0 ? state.userData.enterprises : [],
    enterpriseId: state.userData.enterprises.length > 0 ? state.userData.enterprises[state.userData.currentEnterprise].id : "",
    enterpriseName: state.userData.enterprises.length > 0 ? state.userData.enterprises[state.userData.currentEnterprise].name : "",

    //跳转过来的数据
    // applicationId: state.deployMarketApp.applicationId,
    appVersionId: state.deployMarketApp.appVersionId,
    appPlanId: state.deployMarketApp.appPlanId,
    appPeriodId: state.deployMarketApp.appPeriodId,
    periods: state.deployMarketApp.periods,
    users: state.deployMarketApp.users,

    appVersion: state.deployMarketApp.appVersion,
    spaces: state.deployMarketApp.spaces,
    deployTitle: state.deployMarketApp.deployTitle,
    spaceId: state.deployMarketApp.spaceId,
    diskQuota: state.deployMarketApp.diskQuota,
    memoryQuota: state.deployMarketApp.memoryQuota,
    randomRoute: state.deployMarketApp.randomRoute,
    runtimeStart: state.deployMarketApp.runtimeStart,
    runtimeEnd: state.deployMarketApp.runtimeEnd,
    application: state.deployMarketApp.application,
    cost: state.deployMarketApp.cost,
    namespace: state.deployMarketApp.namespace,
    balance: state.deployMarketApp.namespace,
    majorId: state.deployMarketApp.majorId,

    modalVisible: state.deployMarketApp.modalVisible,
    modalTitle: state.deployMarketApp.modalTitle,
    modalContent: state.deployMarketApp.modalContent,
    modalVisitUrl: state.deployMarketApp.modalVisitUrl,
    modalOk: state.deployMarketApp.modalOk,
    modalCancel: state.deployMarketApp.modalCancel,
    onOk: state.deployMarketApp.onOk,
    onCancel: state.deployMarketApp.onCancel,
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch,
    update(data) {
      dispatch(updateDeployMarketAppData(data))
    },
    handleLoginClick() {
      dispatch({type: LOGIN});
    },
    onSubmit(data, history) {
      dispatch(deployApplication(data, history))
    },
    onReturn() {
      ownProps.history.goBack()
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeployMarketAppPage)
